module.exports = __webpack_public_path__ + "img/MrFixit.ef217270.png";